import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { Loading } from 'framework/ui/mui-builder';
import { ListProvider, StaticFilters } from 'framework/list';
import { ProjectSectionAccordion } from 'domain/shared/newProject';
import { useProjectHeatmap } from './useProjectHeatmap';
import ProjectHeatmapWrapper from './components/ProjectHeatmapWrapper';
import { ShowSection } from 'framework/ui/layout';

const ProjectTeamHeatmapSection = () => {
  const { contextValue, heatmapFilters, getValidationSchema } = useProjectHeatmap();
  const isLoadingLeaves = contextValue.data?.isLoadingLeaves;

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <ListProvider value={contextValue}>
        <StaticFilters getValidationSchema={getValidationSchema}>
          <ProjectSectionAccordion
            defaultExpanded
            title={
              <Grid container direction="row" justifyContent="space-between" alignItems="center" pl={2} width="100%">
                <Grid size={2.3}>
                  <Typography variant="h4" color="primary">
                    Project gantt
                  </Typography>
                </Grid>

                <Grid
                  size="auto"
                  alignItems="center"
                  sx={{ '.filter-item-wrapper': { mb: 0 }, '.filters-reset-btn': { mb: 0 } }}
                >
                  {heatmapFilters}
                </Grid>

                <Grid size="grow" />
              </Grid>
            }
          >
            {isLoadingLeaves ? (
              <Loading isInitialPosition />
            ) : (
              <Box px={2} py={1}>
                <ProjectHeatmapWrapper />
              </Box>
            )}
          </ProjectSectionAccordion>
        </StaticFilters>
      </ListProvider>
    </ShowSection>
  );
};

export default ProjectTeamHeatmapSection;
